/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VcdsTenantOrg { 
    org_id: string;
    org_name: string;
    org_type?: string;
    vcdr_ungated?: boolean;
    vmcfs_ungated?: boolean;
    vmua_ungated?: boolean;
}

